package com.wintermar.inspection.navigation

import androidx.compose.ui.graphics.Color
import org.jetbrains.compose.resources.DrawableResource

data class RouteContentModel(
    val title: String,
    val resIcon: DrawableResource,
    val tint: Color
)
